import useSWR from 'swr/immutable'
import { SubModuleSubmission } from '../generated/graphql'
import { requestGet } from '../utils/services'

const useSubmoduleSubmission = (subModuleSubmissionId?: string) => {
  const submoduleSubmissionKey = subModuleSubmissionId
    ? `/sub-module-submissions/${subModuleSubmissionId}/full`
    : null
  // /sub-module-submissions/${id}?populate[user]=*&populate[sub_module][populate][sections]=*&populate[programme]=*&populate[section][populate]=*
  const { data, mutate, isValidating } = useSWR(
    submoduleSubmissionKey,
    (url: string) => requestGet(url),
    { revalidateOnFocus: false }
  )
  if (data) {
    const raw = data
    return {
      submoduleSubmission: raw as SubModuleSubmission,
      updateSubmission: () => mutate(),
      isLoading: isValidating
    }
  }
  return {
    submoduleSubmission: {} as SubModuleSubmission,
    updateSubmission: () => mutate(),
    isLoading: isValidating
  }
}

export default useSubmoduleSubmission
